(() => {
  const storageKey = 'riot-bike-model';
  const selector = '[data-bike-finder] select';
  const labelFallbacks = new WeakMap();
  const enhancedDialogs = new WeakSet();
  const openers = new WeakMap();
  let defaultLabel = 'Choose your bike';

  const readSavedValue = () => {
    try {
      return window.localStorage.getItem(storageKey);
    } catch (_) {
      return null;
    }
  };

  const availableOption = (select, value) => [...select.options].find(option => (
    value && option.value === value && !option.disabled && !option.parentElement?.disabled
  ));

  const refresh = () => {
    const selects = [...document.querySelectorAll(selector)];
    const value = readSavedValue();
    const option = selects.map(select => availableOption(select, value)).find(Boolean);
    const saved = option ? { value, label: (option.label || option.textContent).trim() } : null;

    selects.forEach(select => {
      select.value = saved && availableOption(select, saved.value) ? saved.value : '';
    });

    document.querySelectorAll('[data-garage-label], [data-garage-current]').forEach(label => {
      if (!labelFallbacks.has(label)) {
        labelFallbacks.set(label, label.textContent.trim() || defaultLabel);
      }
      label.textContent = saved ? saved.label : labelFallbacks.get(label);
    });
  };

  const enhanceDialog = dialog => {
    if (enhancedDialogs.has(dialog)) return;
    enhancedDialogs.add(dialog);
    dialog.addEventListener('close', () => {
      const opener = openers.get(dialog);
      document.querySelectorAll('[data-open-garage]').forEach(trigger => {
        trigger.setAttribute('aria-expanded', 'false');
      });
      if (opener?.isConnected) opener.focus({ preventScroll: true });
      openers.delete(dialog);
    });
  };

  const outsideDialog = (event, dialog) => {
    const rect = dialog.getBoundingClientRect();
    return event.clientX < rect.left || event.clientX > rect.right ||
      event.clientY < rect.top || event.clientY > rect.bottom;
  };

  const initialize = () => {
    const firstLabel = document.querySelector('[data-garage-label]');
    defaultLabel = firstLabel?.textContent.trim() || defaultLabel;
    const dialog = document.getElementById('rr-garage-dialog');
    if (dialog && typeof dialog.showModal === 'function') {
      enhanceDialog(dialog);
      document.querySelectorAll('[data-open-garage]').forEach(trigger => {
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', dialog.id);
        trigger.setAttribute('aria-expanded', String(dialog.open));
      });
    }
    refresh();
  };

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const dialog = document.getElementById('rr-garage-dialog');
    const trigger = event.target.closest('[data-open-garage]');

    if (trigger) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (!dialog || typeof dialog.showModal !== 'function') return;
      refresh();
      enhanceDialog(dialog);
      if (!dialog.open) {
        try {
          dialog.showModal();
        } catch (_) {
          return;
        }
      }
      event.preventDefault();
      openers.set(dialog, trigger);
      document.querySelectorAll('[data-open-garage]').forEach(opener => {
        opener.setAttribute('aria-expanded', 'true');
      });
      dialog.querySelector(selector)?.focus({ preventScroll: true });
      return;
    }

    if (!dialog?.open) return;
    const closeButton = event.target.closest('[data-close-garage]');
    if (closeButton && dialog.contains(closeButton)) {
      event.preventDefault();
      dialog.close();
    } else if (event.target === dialog && outsideDialog(event, dialog)) {
      dialog.close();
    }
  });

  window.addEventListener('storage', event => {
    if (event.key === storageKey || event.key === null) refresh();
  });
  window.addEventListener('pageshow', refresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
